import React from 'react';
import NewEvent from '@/src/components/events/NewEvent';

export const NewEventPage: React.FC = () => {
  return <NewEvent />;
};
